<div class="p-d-flex p-flex-column p-fluid">
  <kodit-field fieldLabel="Zastupnik/ci">
    <kodit-text-input
      ctrlPlaceholder="Unesite zastupnika/e"
      [formCtrl]="zastupniciCtrl"
      formCtrlId="zastupnici"
    ></kodit-text-input>
    <div class=" p-mt-3 p-d-flex p-justify-between">
      <div class="p-d-flex p-align-center">
        <p-checkbox
          id="terms-and-conditions"
          [binary]="true"
          [(ngModel)]="termsAccepted"
        ></p-checkbox>
        <div class="p-ml-2">Prihvatam <a class="cursor-pointer" (click)="downloadContractPreview()">uslove ugovora</a>
        </div>
      </div>
      <kodit-button
        [isBtnDisabled]="!termsAccepted"
        btnLabel="Sačuvaj"
        (btnClicked)="save()"
      ></kodit-button>
    </div>
  </kodit-field>
</div>
